import {ActionContext} from 'vuex'
import { NetworkstatsState } from './networkstats.state'
import { FirestoreDocSnapper, FirestoreSnapperType, RootState } from "@/store/types";
// NOTE: importing store is required to make the module actions load correctly
import store, { storehelper } from '../..'
import fb from '@/firebase'

// see https://codeburst.io/vuex-and-typescript-3427ba78cfa8

type NetworkStateContext = ActionContext<NetworkstatsState, RootState>

function _subscriptionKey (userId: string): string {
  return 'userstats_' + userId
}

export const actions = {
  subscribeUserStats (_context: NetworkStateContext, userId: string) {
    const subscriptionKey = _subscriptionKey(userId)
    const snapper: FirestoreDocSnapper = {
      doc: fb.db.collection('networkstats').doc(userId),
      mutation: store.commit.networkStats.updateUserStats,
      type: FirestoreSnapperType.Document
    }
    storehelper.subscribe(subscriptionKey, snapper)
  },
  unsubscribeUserStats (_context: NetworkStateContext, userId: string) {
    const subscriptionKey = _subscriptionKey(userId)
    storehelper.unsubscribe(subscriptionKey)
  }
}
